import React, { useEffect, useState } from 'react';
import useIsMobile from '../../hooks/useIsMobile';

import styles from './styles.module.scss';

type TResizeable = React.HTMLAttributes<HTMLDivElement>;

const Resizeable: React.FC<TResizeable> = ({ 
  children
}) => {
  const isMobile = useIsMobile();
  const [expanded, setExpanded] = useState(false);

  const handleTouchStart: React.TouchEventHandler<HTMLDivElement> = (touchStartEvent) => {
    if (!isMobile) return;

    const startY = touchStartEvent.changedTouches[0].clientY;

    const onTouchEnd = (touchEndEvent: any) => {
      const endY = touchEndEvent.changedTouches[0].clientY;
      if (endY < startY) setExpanded(true);
      else setExpanded(false);
    };
        
    document.body.addEventListener('touchend', onTouchEnd, { once: true });
  };

  return (
    <div
      className={styles.resizeable}
      data-expanded={expanded}
      onTouchStart={handleTouchStart}
    >
      {children}
    </div>
  );
};

export default Resizeable;